class ProductTabs {
  constructor() {
    this.tabLinks = [];
    this.tabContents = [];
    this.currentTabIndex = 0;
    
    this.init();
  }

  init() {
    this.initProductTabs();
    this.initLazyVideos();
  }

  initProductTabs() {
    this.tabLinks = Array.from(document.querySelectorAll('.product-tab-link'));
    this.tabContents = Array.from(document.querySelectorAll('.product-tab-content'));

    if (this.tabLinks.length === 0 || this.tabContents.length === 0) return;

    // Resolve initial tab from URL hash before touching history
    const initialHash = window.location.hash.substring(1);
    let initialIndex = 0;
    if (initialHash) {
      const hashIndex = this.tabLinks.findIndex(tab => {
        const title = tab.querySelector('span')?.textContent || '';
        return this.getUrlSafeTitle(title) === initialHash;
      });
      if (hashIndex !== -1) initialIndex = hashIndex;
    }

    this.isInitialLoad = true;
    this.showTab(initialIndex);
    this.isInitialLoad = false;

    this.tabLinks.forEach((link, index) => {
      link.addEventListener('click', () => this.showTab(index));

      link.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.showTab(index);
        }
      });
    });

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);
  }

  showTab(index) {
    this.tabLinks.forEach(link => link.classList.remove('current'));
    this.tabContents.forEach(content => content.classList.remove('current'));
    
    if (this.tabLinks[index]) this.tabLinks[index].classList.add('current');
    if (this.tabContents[index]) this.tabContents[index].classList.add('current');
    
    this.currentTabIndex = index;
    
    this.scrollTabIntoView(index);
    
    if (window.history && window.history.pushState) {
      const tabTitle = this.tabLinks[index]?.querySelector('span')?.textContent || '';
      const urlSafeTitle = this.getUrlSafeTitle(tabTitle);
      if (this.isInitialLoad) {
        window.history.replaceState(null, null, `#${urlSafeTitle}`);
      } else {
        window.history.pushState(null, null, `#${urlSafeTitle}`);
      }
    }
  }

  handleHashChange() {
    const hash = window.location.hash.substring(1);
    if (!hash) return;
    const tabIndex = this.tabLinks.findIndex(tab => {
      const title = tab.querySelector('span')?.textContent || '';
      return this.getUrlSafeTitle(title) === hash;
    });
    if (tabIndex === -1) return;
    // URL is already correct (changed by browser back/forward) — only update UI
    this.tabLinks.forEach(link => link.classList.remove('current'));
    this.tabContents.forEach(content => content.classList.remove('current'));
    if (this.tabLinks[tabIndex]) this.tabLinks[tabIndex].classList.add('current');
    if (this.tabContents[tabIndex]) this.tabContents[tabIndex].classList.add('current');
    this.currentTabIndex = tabIndex;
    this.scrollTabIntoView(tabIndex);
  }

  scrollTabIntoView(index) {
    const activeTab = this.tabLinks[index];
    const tabsContainer = document.querySelector('[data-tabs-nav]');
    
    if (!activeTab || !tabsContainer) return;
    
    const containerRect = tabsContainer.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
    
    const scrollLeft = tabsContainer.scrollLeft;
    const tabLeft = tabRect.left - containerRect.left;
    const tabWidth = tabRect.width;
    const containerWidth = containerRect.width;
    
    const targetScrollLeft = scrollLeft + tabLeft - (containerWidth / 2) + (tabWidth / 2);
    
    tabsContainer.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
  }



  initLazyVideos() {
    const lazyVideos = document.querySelectorAll('.product-lazy-video');
    
    if (lazyVideos.length === 0) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const video = entry.target;
          if (video.paused) {
            video.load();
          }
          observer.unobserve(video);
        }
      });
    });
    
    lazyVideos.forEach(video => {
      observer.observe(video);
    });
  }

  getUrlSafeTitle(title) {
    return title
      .toLowerCase()
      .replace(/\s+/g, '-')        
      .replace(/[^a-z0-9\-]/g, '') 
      .replace(/-+/g, '-')         
      .replace(/^-+|-+$/g, '');    
  }

  getCurrentTabIndex() {
    return this.currentTabIndex;
  }

  getTabCount() {
    return this.tabLinks.length;
  }

  static showTab(index) {
    if (window.productTabsInstance) {
      window.productTabsInstance.showTab(index);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.productTabsInstance = new ProductTabs();
});

window.ProductTabs = ProductTabs;
